import { IFaqItemProps } from '@/features/faq/faq-item'
import { ILinkParams, IUrlPattern } from '@/setup/routing'
import {
    type FaqButton,
    type ParsedFaqContent,
    parseFaqMarkdown as parseWithRemark,
    markdownToHtml as remarkMarkdownToHtml,
    markdownToText as remarkMarkdownToText,
} from './remark-utils'

export async function parseFaqMarkdown(markdown: string): Promise<ParsedFaqContent> {
    return await parseWithRemark(markdown)
}

export async function markdownToTextAsync(markdown: string): Promise<string> {
    return await remarkMarkdownToText(markdown)
}

export async function markdownToHtmlAsync(markdown: string): Promise<string> {
    return await remarkMarkdownToHtml(markdown)
}

export function buttonToCta(button: FaqButton): IFaqItemProps['cta'] {
    return {
        label: button.label,
        href:
            button.type === 'internal'
                ? ({
                      pattern: button.href as IUrlPattern,
                      params: undefined,
                  } as unknown as ILinkParams<IUrlPattern>)
                : { externalUrl: button.href },
    }
}
